import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// Overlay de carga. Antes usaba position:absolute con top:0 pero sin left/right,
// y height/width por props ("100%", "90%"): el alto porcentual depende de que el
// ancestro tenga altura definida y el absolute se anclaba al primer ancestro
// posicionado, que no siempre era el contenedor esperado (el Paper de un Dialog
// no es relative). El resultado era un spinner corrido y tapando de mas.
//
// `inset: 0` lo estira al contenedor sin depender de porcentajes. Las props
// height/width se siguen aceptando por compatibilidad con los llamadores, pero
// solo se aplican si se pasan explicitamente distintas de "100%".
export default function CircularIndeterminate(props) {
  const { color, height, width } = props;
  const sizeOverrides = {};
  if (height && height !== '100%') sizeOverrides.height = height;
  if (width && width !== '100%') sizeOverrides.width = width;

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'absolute',
        inset: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: color,
        zIndex: 5000,
        ...sizeOverrides,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
